<template>
  <v-btn
    color="pwt_palatinate_blue"
    block
    variant="outlined"
    :disabled="disabled"
    :loading="loading"
    class="text-none px-5"
    :class="shape === 'pill' ? 'rounded-pill' : 'rounded-lg' "
    @click.stop="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">

interface Props {
  loading?: boolean
  disabled?: boolean
  shape?: 'pill' | 'box' 
}

const { loading = false, disabled = false, shape = 'pill' } = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
